<app-loader *ngIf="loading"></app-loader>
<div class="row notification full-notification bg-primary" *ngIf="waitingPayment">
  <div class="col d-flex flex-column">
    <div class="loader mb-3">
      <div class="loader-inner ball-pulse">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <!-- MBWAY -->
    <ng-container *ngIf="form.get('paymentMethod').value.id === 'mbway'">
      <h3>{{ 'SHARED.paymentModal.waitingMBWayPayment' | translate }}</h3>
      <p>{{ 'SHARED.paymentModal.authorizeMBWayPayment' | translate }}</p>
    </ng-container>

    <!-- MBREF -->
    <ng-container *ngIf="form.get('paymentMethod').value.id === 'mbref' && mbrefDetails">
      <h3 class="mb-4">{{ 'SHARED.paymentModal.waitingPayment' | translate }}</h3>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-6">
            <div class="mb-card">
              <div class="d-flex mb-1">
                <img style="width: 50%; height: auto; margin: 0 auto;" class="mb-2" src="assets/logo-mb.png" alt="">
              </div>
              <div class="d-flex mb-1">
                <div class="item w-50 text-right"><p class="color-gray mb-0">{{ 'SHARED.paymentModal.mbrefEntity' | translate }}</p></div>
                <div class="item w-50 text-left"><p class="ml-2 mb-0 text-bold">{{mbrefDetails.entidade}}</p></div>
              </div>
              <div class="d-flex mb-1">
                <div class="item w-50 text-right"><p class="color-gray mb-0">{{ 'SHARED.paymentModal.mbrefReference' | translate }}</p></div>
                <div class="item w-50 text-left"><p class="ml-2 mb-0 text-bold">{{convertMBref(mbrefDetails.referencia)}}</p></div>
              </div>
              <div class="d-flex mb-1">
                <div class="item w-50 text-right"><p class="color-gray mb-0">{{ 'SHARED.paymentModal.mbrefAmount' | translate }}</p></div>
                <div class="item w-50 text-left"><p class="ml-2 mb-0 text-bold">{{mbrefDetails.valor | currency: selectedPlanAnnually?.currency:'symbol-narrow':'1.0-2'}}</p></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <div>
      <button class="btn btn-sm mt-3" (click)="cancelPayment()">{{ 'SHARED.paymentModal.cancel' | translate }}</button>
    </div>
  </div>
</div>

<div class="md-modal" *ngIf="!loading && !waitingPayment">
  <div class="md-content">
    <i class="material-icons md-close" (click)="close()">close</i>

    <!-- HEADER -->
    <div class="md-header" *ngIf="!submitSuccess">
      <h3 *ngIf="!changePaymentMethodOnly">{{ 'SHARED.paymentModal.title' | translate }}</h3>
      <h3 *ngIf="changePaymentMethodOnly">{{ 'SHARED.paymentModal.changeCard' | translate }}</h3>

      <p class="subtext">
        <span>{{ 'SHARED.paymentModal.plan' | translate: { value: selectedPlanMonthly?.nickname } }}</span>
        <span class="ml-1"
          >({{ quantity }}
          <span *ngIf="quantity === 1">{{ 'SHARED.plansModal.provider' | translate }}</span>
          <span *ngIf="quantity > 1">{{ 'SHARED.plansModal.providers' | translate }}</span
          >)</span
        >
        <span class="color-green ml-2" *ngIf="form.get('frequency').value.id === 'yearly'">-20%</span>
      </p>


    </div>
    <!-- HEADER SUCCESS -->
    <div class="md-header" *ngIf="submitSuccess">
      <i class="material-icons ico-check">check_circle</i>
      <h3 class="mb-3">{{ 'SHARED.paymentModal.successPaymentTitle' | translate }}</h3>
      <p class="text-secondary font-bold mb-2">{{ 'SHARED.paymentModal.successPaymentMsg' | translate }}</p>
      <p class="text-secondary mb-4">{{ 'SHARED.paymentModal.successPaymentMsg2' | translate }}</p>
      <div class="d-flex align-items-center justify-content-center">
        <button class="btn btn-md btn-secondary mr-2" (click)="close()">{{ 'SHARED.close' | translate }}</button>
        <button class="btn btn-md btn-primary" (click)="goToReferral()">{{ 'SHARED.paymentModal.successPaymentInviteFriends' | translate }}</button>
      </div>
    </div>

    <!-- BODY -->
    <div class="md-body" *ngIf="!submitSuccess">
      <div class="row justify-content-center">
        <div class="col-md-10">
          <!-- Common -->
          <form [formGroup]="form" class="form" *ngIf="form">
            <ng-container *ngIf="!submitSuccess">

              <!-- Payment Method -->
              <app-dropdown-input-v2
                label="{{ 'SHARED.paymentModal.paymentMethod' | translate }}"
                formControlName="paymentMethod"
                [options]="paymentMethodOptions"
                textOption="value"
                [submitAttempted]="submitAttempted"
              ></app-dropdown-input-v2>

              <!-- Enter card -->
              <div
                class="form-group"
                [style.display]="form.get('paymentMethod').value.id === 'ccard' && (!activeCreditCard || changePaymentMethodOnly) ? '' : 'none'"
              >
                <app-stripe-elements-form [type]="'cccard'" [stripe]="stripe" 
                  (cardCreated)="card = $event"
                  (elementEmpty)="cardEmpty = $event"
                  > </app-stripe-elements-form>
              </div>

              <!-- Read only card -->
              <div *ngIf="form.get('paymentMethod').value.id === 'ccard' && activeCreditCard && !changePaymentMethodOnly">
                <app-text-input
                  label="{{ 'SHARED.paymentModal.creditCardNumberLabel' | translate }}"
                  formControlName="readOnlyCard"
                ></app-text-input>

                <div class="d-flex justify-content-end mt-2">
                  <small class="clickable mb-3 d-block underline" (click)="activeCreditCard = null; errorMsg = null">{{
                    'SHARED.paymentModal.changeCard' | translate
                  }}</small>
                </div>
              </div>

              <!-- Direct Debit -->
              <div class="form-group" [style.display]="form.get('paymentMethod').value.id === 'sepa' && (!activeDirectDebit || changePaymentMethodOnly) && merchant?.allowSepa ? '' : 'none'">
                <app-text-input
                  label="{{ 'SHARED.paymentModal.sepaName' | translate }}"
                  formControlName="sepaName"
                  [submitAttempted]="submitAttempted"
                  invalidMsg="{{ 'SHARED.paymentModal.invalidSepaName' | translate }}"
                ></app-text-input>

                <app-stripe-elements-form [type]="'sepa'" [stripe]="stripe" 
                  (cardCreated)="iban = $event"
                  (elementEmpty)="ibanEmpty = $event">
                </app-stripe-elements-form>
              </div>

              <!-- Read only Direct Debit -->
              <div *ngIf="form.get('paymentMethod').value.id === 'sepa' && activeDirectDebit && !changePaymentMethodOnly && merchant?.allowSepa">
                <app-text-input label="{{ 'SHARED.paymentModal.sepaLabel' | translate }}"
                  formControlName="readOnlyDirectDebit"></app-text-input>

                <div class="d-flex justify-content-end mt-2">
                  <small class="clickable mb-3 d-block underline" (click)="activeDirectDebit = null; errorMsg = null">{{
                    'SHARED.paymentModal.changeSepa' | translate
                    }}</small>
                </div>
              </div>

              <div *ngIf="form.get('paymentMethod').value.id === 'sepa' && !merchant?.allowSepa">
                <app-alert [msg]="'SHARED.paymentModal.sepaNotAllowed' | translate " type="danger"></app-alert>
              </div>

              <!-- mbWay number -->
              <div *ngIf="form.get('paymentMethod').value.id === 'mbway'">
                <app-text-input
                  label="{{ 'SHARED.paymentModal.phoneMbway' | translate }}"
                  [requiredMark]="true"
                  [submitAttempted]="submitAttempted"
                  formControlName="phoneNumber"
                  placeholder="{{ 'DASHBOARD.storeSettingsPage.phonePlaceholder' | translate }}"
                  inputType="text"
                  invalidMsg="{{ 'DASHBOARD.storeSettingsPage.invalidPhone' | translate }}"
                ></app-text-input>
                <p class="color-primary">
                  {{ 'SHARED.paymentModal.mbwayNotification1' | translate }}
                  <strong>{{ 'SHARED.paymentModal.mbwayNotification2' | translate }} {{ invoice?.amountToPayNow / 100 | currencyConverter }}€ </strong>
                </p>
              </div>

              <ng-container *ngIf="form.get('paymentMethod').value.id !== 'sepa' || merchant?.allowSepa">
                <!-- VAT -->
                <app-text-input
                  *ngIf="showVatInput"
                  groupClasses="vat-number"
                  label="{{ 'SHARED.paymentModal.vatNumber' | translate }}"
                  autocomplete="off"
                  formControlName="vatNumber"
                  [submitAttempted]="submitAttempted"
                  inputType="text"
                  invalidMsg="{{form.get('vatNumber').errors?.vatInvalid?.message}}"
                  placeholder="123456789"
                ></app-text-input>

                <!-- cupons -->
                <app-text-input
                  *ngIf="!changePaymentMethodOnly && !isUsingReferral"
                  inputClasses="cards"
                  label="{{ 'SHARED.paymentModal.couponCode' | translate }}"
                  autocomplete="off"
                  formControlName="coupon"
                  [submitAttempted]="submitAttempted"
                  placeholder="{{ 'SHARED.paymentModal.couponCodePlaceholder' | translate }}"
                  inputType="text"
                  invalidMsg="{{ 'SHARED.paymentModal.couponCodeInvalid' | translate }}"
                ></app-text-input>

              </ng-container>

              <!-- Frequency -->
              <app-dropdown-input-v2
                label="{{ 'SHARED.paymentModal.paymentPeriod' | translate }}"
                formControlName="frequency"
                [options]="frequencyOptions"
                textOption="value"
                [submitAttempted]="submitAttempted"
                *ngIf="!changePaymentMethodOnly"
              ></app-dropdown-input-v2>

            </ng-container>
            <app-alert [msg]="errorMsg" type="danger"></app-alert>

            <!-- <app-alert [msg]="submitSuccess" type="success"></app-alert> -->

            <div class="price-summary" *ngIf="!submitSuccess">
              <ng-container *ngIf="!loadingUpcomingInvoice">
                <!-- Monthly Price -->
                <div class="d-flex flex-column mt-3" *ngIf="form.get('frequency').value.id !== 'yearly'">
                  <div class="price-item d-flex flex-row justify-content-between" *ngIf="showPriceWithoutVat">
                    <p class="mb-0">{{ 'SHARED.paymentModal.subscription' | translate }}</p>
                    <p class="mb-0">{{ plansService.getPlanPrice(selectedPlanMonthly, true, quantity) | currency: selectedPlanMonthly?.currency:'symbol-narrow':'1.0-2' }}</p>
                  </div>
                  <div class="price-item d-flex flex-row justify-content-between" *ngIf="showPriceWithoutVat">
                    <p class="mb-0">{{ 'SHARED.paymentModal.vat' | translate }} ({{invoice?.vatRate || 23}}%)</p>
                    <p class="mb-0">{{ (getVatPrice(selectedPlanMonthly)) | currency: selectedPlanMonthly?.currency:'symbol-narrow':'1.0-2' }}</p>
                  </div>
                  <div class="price-item price-total d-flex flex-row justify-content-between">
                    <p class="mb-0 text-bold">{{ 'SHARED.paymentModal.totalMonthly' | translate }}</p>
                    <p class="mb-0 text-bold color-primary">{{ getTotalPlanPrice(selectedPlanMonthly) | currency: selectedPlanMonthly?.currency:'symbol-narrow':'1.0-2' }}</p>
                  </div>
                  <div class="price-item price-total d-flex flex-row justify-content-between ref-discount" *ngIf="isUsingReferral">
                    <p class="mb-0 text-bold">{{ 'SHARED.paymentModal.referralDiscount' | translate }}</p>
                    <p class="mb-0 text-bold color-primary">-{{ getReferralDiscount(selectedPlanMonthly) | currency: selectedPlanMonthly?.currency:'symbol-narrow':'1.0-2' }}</p>
                  </div>
                  <div *ngIf="invoice" class="price-item price-total d-flex flex-row justify-content-between">
                    <p class="mb-0 text-bold">{{ 'SHARED.paymentModal.payNow' | translate }}</p>
                    <p class="mb-0 text-bold color-primary">{{ invoice?.amountToPayNow / 100 | currency: selectedPlanMonthly?.currency:'symbol-narrow':'1.0-2'}}</p>
                  </div>
                </div>

                <!-- Yearly price -->
                <div class="d-flex flex-column mt-3" *ngIf="form.get('frequency').value.id === 'yearly'">
                  <div class="price-item d-flex flex-row justify-content-between" *ngIf="showPriceWithoutVat">
                    <p class="mb-0">{{ 'SHARED.paymentModal.subscription' | translate }}</p>
                    <p class="mb-0">{{ plansService.getPlanPrice(selectedPlanAnnually, true, quantity) | currency: selectedPlanAnnually?.currency:'symbol-narrow':'1.0-2' }} </p>
                  </div>
                  <div class="price-item d-flex flex-row justify-content-between" *ngIf="showPriceWithoutVat">
                    <p class="mb-0">{{ 'SHARED.paymentModal.vat' | translate }} ({{invoice?.vatRate || 23}}%)</p>
                    <p class="mb-0">{{ ((getVatPrice(selectedPlanAnnually))) | currency: selectedPlanAnnually?.currency:'symbol-narrow':'1.0-2' }} </p>
                  </div>
                  <div class="price-item price-total d-flex flex-row justify-content-between">
                    <p class="mb-0 text-bold">{{ 'SHARED.paymentModal.totalYearly' | translate }}</p>
                    <p class="mb-0 text-bold color-primary">
                      <span class="old-price">{{ getTotalPlanPrice(selectedPlanMonthly) * 12 | currency: selectedPlanMonthly?.currency:'symbol-narrow':'1.0-2' }}</span>
                      <span class="ml-2">{{ getTotalPlanPrice(selectedPlanAnnually) | currency: selectedPlanAnnually?.currency:'symbol-narrow':'1.0-2' }}</span>
                    </p>
                  </div>
                  <div class="price-item price-total d-flex flex-row justify-content-between ref-discount" *ngIf="isUsingReferral">
                    <p class="mb-0 text-bold">{{ 'SHARED.paymentModal.referralDiscount' | translate }}</p>
                    <p class="mb-0 text-bold color-primary">-{{ getReferralDiscount(selectedPlanAnnually) | currency: selectedPlanAnnually?.currency:'symbol-narrow':'1.0-2' }}</p>
                  </div>
                  <div *ngIf="invoice" class="price-item price-total d-flex flex-row justify-content-between">
                    <p class="mb-0 text-bold">{{ 'SHARED.paymentModal.payNow' | translate }}</p>
                    <p class="mb-0 text-bold color-primary">{{ invoice?.amountToPayNow / 100 | currency: selectedPlanAnnually?.currency:'symbol-narrow':'1.0-2'}}</p>
                  </div>
                  <div class="price-item price-total price-discount text-center" *ngIf="!merchantIsOnAnnualPlan">
                    <p class="mb-0">
                      {{ 'SHARED.paymentModal.youAreSaving' | translate }}
                      {{ getTotalPlanPrice(selectedPlanMonthly) * 12 - (invoice?.amountToPayNow / 100) | currency: selectedPlanMonthly?.currency:'symbol-narrow':'1.0-2' }}
                      🥳
                    </p>
                  </div>
                </div>
              </ng-container>

              <!-- Reloading... -->
              <div class="d-flex flex-column mt-3" *ngIf="loadingUpcomingInvoice">
                <div class="price-item d-flex flex-row justify-content-center p-4">
                  <app-loader></app-loader>
                </div>
              </div>

            </div>

            <div *ngIf="isUsingReferral" class="d-flex flex-row align-items-center mt-3 p-3 referralMsg">
              <span class="icon mr-3">🎁</span>
              <div class="d-flex flex-column">
                <p class="text-bold mb-1">{{ 'SHARED.paymentModal.referralText' | translate }}</p>
                <p class="mb-0">{{ 'SHARED.paymentModal.referralText2' | translate }}</p>
              </div>
            </div>

            <ng-container *ngIf="form.get('paymentMethod').value.id !== 'sepa' || merchant?.allowSepa">
              <!-- ACTIONS  -->
              <div class="md-actions" *ngIf="!submitSuccess">
                <!-- Pay -->
                <app-submit-btn
                  inputClasses="btn-rd w100"
                  [btnCopy]="changePaymentMethodOnly ? ('SHARED.paymentModal.changePaymentMethod' | translate) : ('SHARED.paymentModal.activate' | translate)"
                  [loading]="submitting"
                  [hasError]="errorMsg"
                  (click)="submit($event)"
                >
                </app-submit-btn>

                <!-- Back to plans -->
                <button type="button" [disabled]="submitting" (click)="backToPlans()" class="btn btn-md btn-outline mt-3 w-100">
                  {{ 'SHARED.paymentModal.backToPlans' | translate }}
                </button>
              </div>
            </ng-container>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
